if (!customElements.get('ys-series-floating-cart')) {
  customElements.define('ys-series-floating-cart', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.button = this.querySelector('button[aria-controls]');
      this.panel = this.querySelector('.ys-series-floating-cart__panel');
      this.button.addEventListener('click', () => {
        const collapsed = this.classList.toggle('is-collapsed');
        this.panel.hidden = collapsed;
        this.button.setAttribute('aria-expanded', String(!collapsed));
        this.button.setAttribute('aria-label', collapsed ? 'Expand quick add' : 'Collapse quick add');
        this.querySelector('[data-toggle-label]').textContent = collapsed ? 'Quick add' : '×';
      }, { signal });
      this.inlineCtaVisible = false;
      const update = () => { this.hidden = this.inlineCtaVisible || window.scrollY < Number(this.dataset.delay || 0); };
      if (this.dataset.avoidFaqCta === 'true') {
        const inlineCta = document.querySelector('[data-ys-faq-support], .ys-saki-faqp__final');
        if (inlineCta) {
          this.ctaObserver?.disconnect();
          this.ctaObserver = new IntersectionObserver(entries => {
            this.inlineCtaVisible = entries.some(entry => entry.isIntersecting);
            update();
          }, { threshold: 0 });
          this.ctaObserver.observe(inlineCta);
        }
      }
      window.addEventListener('scroll', update, { passive: true, signal });
      update();
    }
    disconnectedCallback() { this.ctaObserver?.disconnect(); this.controller?.abort(); }
  });
}
